import ArticleRenderer from "./Article";
import "./App.css";
import {
  Alignment,
  Button,
  Card,
  Classes,
  Colors,
  Icon,
  InputGroup,
  Navbar,
} from "@blueprintjs/core";
import { useTheme } from "./theme";
import { useEffect, useState } from "react";

function App() {
  const [query, setQuery] = useState("");
  const [theme, toggleTheme] = useTheme();

  useEffect(() => {
    if (typeof document !== "undefined") {
      theme === Classes.DARK
        ? (document.body.style.backgroundColor = Colors.DARK_GRAY2)
        : (document.body.style.backgroundColor = Colors.LIGHT_GRAY2);
    }
  }, [theme]);

  return (
    <div className={`App ${theme}`}>
      <Navbar>
        <Navbar.Group align={Alignment.LEFT}>
          <Navbar.Heading>
            <Button
              className="bp5-minimal"
              icon="home"
              text="Cognipedia"
              onClick={() => {
                window.location.href = "/";
              }}
            />
          </Navbar.Heading>
        </Navbar.Group>
        <Navbar.Group align={Alignment.LEFT}>
          <Navbar.Heading>
            <InputGroup
              large
              leftIcon="search"
              placeholder="Search..."
              round={false}
              type="search"
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={(event) => {
                if (event.code === "Enter") {
                  window.location.href = `/?title=${event.currentTarget.value}`;
                }
              }}
            />
          </Navbar.Heading>
        </Navbar.Group>
        <Navbar.Group align={Alignment.RIGHT}>
          <Navbar.Heading>
            <Button
              className="bp5-minimal"
              icon="moon"
              onClick={() => {
                toggleTheme();
              }}
            />
          </Navbar.Heading>
        </Navbar.Group>
      </Navbar>
      <Card>
        <ArticleRenderer />
      </Card>
    </div>
  );
}

export default App;
